import React from "react";

const StyledLgText = ({ children, fontColor }) => {
  return (
    <p className={`text-lg  leading-[150%] ${fontColor}`}>
      {children}
    </p>
  );
};

export default StyledLgText;
